import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useOutletContext, Link, useLocation } from "react-router-dom";
import { getUser } from "../../../_api/Admin";
import { Loader } from "../../../_helpers/components/Forms/Loader";
import InformationsIndividualTab from "./Tabs/InformationsIndividuals";
import CompteursTab from "./Tabs/Compteurs";
import ParametresTab from "./Tabs/Parametres";
import ContratsTab from "./Tabs/Contrats";
import OrganisationTab from "./Tabs/Organisation";
import PointageTab from "./Tabs/Pointage";
import OperationsTab from "./Tabs/Operations";
import { subMenu } from "../../../Menu";
import { BackButton } from "../../../_helpers/components/BackButton";

export const IndividualProfile = () => {
    const [user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu] = useOutletContext();
    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["INFOS"]["features"];
    const features_right_counters = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["COUNTERS_USER"]["features"];

    const navigate = useNavigate();
    const [profile, setProfile] = useState(null);
    const { user_id } = useParams();

    const loadProfil = () => {
        getUser(user_id).then((resp) => {
            setProfile(resp.data);
            if (String(resp.data?.id) === String(user?.id)) {
                setUser(resp.data);
            }
        });
    };

    const { pathname, hash } = useLocation();

    useEffect(() => {
        loadProfil();
    }, [user_id]);

    const menuRight = user.policy.rights[currentApp][currentMenu.id]["sub_menu"];

    const filteredMenu = subMenu.filter(menu => {
        if (menu.page !== "EMPLOYEES") return false;
        if (menu.id === "CHECKING_RULES" && !profile?.use_time_tracking) return false;
        return menuRight[menu.id]?.["access"];
    });

    return (
        <>
            {!profile ? (
                <Loader text="Chargement du profil..." />
            ) : (
                <div className="min-h-full bg-gray-50">
                    {/* Header avec informations du profil */}
                    <div className="bg-white border-b border-gray-200 shadow-sm">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-4">
                                    <BackButton
                                        onClick={() => navigate("/team")}
                                        title="Retour à la liste"
                                    />
                                    <div className="flex items-center space-x-4">
                                        <div className="flex items-center justify-center w-12 h-12 bg-linear-to-br from-app-primary to-app-secondary rounded-full text-white font-bold text-lg">
                                            {profile?.first_name?.[0]?.toUpperCase() || ""}
                                            {profile?.last_name?.[0]?.toUpperCase() || ""}
                                        </div>
                                        <div>
                                            <h1 className="text-2xl font-bold text-gray-900">
                                                {profile?.first_name} {profile?.last_name}
                                            </h1>
                                            {profile?.email && (
                                                <p className="text-sm text-gray-500 mt-1">
                                                    {profile.email}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Navigation par onglets */}
                    <div className="bg-white border-b border-gray-200">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6">
                            <nav className="flex space-x-1 overflow-x-auto">
                                {filteredMenu.map((tab) => {
                                    const isActive = hash === tab.to || (!hash && tab.to === "#informations");
                                    return (
                                        <div key={tab.to}>
                                            {tab.separator && (
                                                <div className="h-8 w-px bg-gray-300 mx-2" />
                                            )}
                                            <Link
                                                onClick={() => {
                                                    setCurrentTab(tab);
                                                }}
                                                to={tab.to}
                                                className={`
                                                    flex items-center px-4 py-3 text-sm font-medium transition-all duration-200 whitespace-nowrap
                                                    ${isActive
                                                        ? "text-app-primary border-b-2 border-app-primary bg-app-primary/5"
                                                        : "text-gray-600 hover:text-app-primary hover:bg-gray-50 border-b-2 border-transparent"
                                                    }
                                                `}
                                            >
                                                <svg
                                                    className="shrink-0 mr-2 w-5 h-5"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d={tab.svg}
                                                    />
                                                </svg>
                                                {tab.title}
                                            </Link>
                                        </div>
                                    );
                                })}
                            </nav>
                        </div>
                    </div>

                    {/* Contenu des onglets */}
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
                        {(hash === "#informations" || !hash) && (
                            <InformationsIndividualTab
                                profile={profile}
                                refreshProfil={loadProfil}
                            />
                        )}
                        {hash === "#compteurs" && (
                            <CompteursTab
                                profile={profile}
                                features_right={features_right_counters}
                            />
                        )}
                        {hash === "#parametres" && (
                            <ParametresTab
                                profile={profile}
                                refreshProfil={loadProfil}
                            />
                        )}
                        {hash === "#contrats" && (
                            <ContratsTab
                                profile={profile}
                                refreshProfil={loadProfil}
                                onDataChange={(data) => {
                                    // Pour la création d'utilisateur
                                }}
                            />
                        )}
                        {hash === "#organisation" && (
                            <OrganisationTab
                                profile={profile}
                                refreshProfil={loadProfil}
                                onDataChange={(data) => {
                                    // Pour la création d'utilisateur
                                }}
                            />
                        )}
                        {hash === "#pointage" && profile?.use_time_tracking && (
                            <PointageTab
                                profile={profile}
                                refreshProfil={loadProfil}
                            />
                        )}
                        {hash === "#operations" && (
                            <OperationsTab
                                profile={profile}
                                refreshProfil={loadProfil}
                            />
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default IndividualProfile;
